import React from 'react';
import './style.css'; // Import the CSS file

const ProgressBar = ({ currentStep }) => {
    const hr1Class = currentStep >= 0 ? 'hr1' : 'hr';
    const hr2Class = currentStep >= 1 ? 'hr1' : 'hr';
    const hr3Class = currentStep >= 2 ? 'hr1' : 'hr';

    return (
        <div className="progress-bar">
            <hr className={hr1Class} />
            <hr className={hr2Class} />
            <hr className={hr3Class} />
        </div>
    );
};

export default ProgressBar;
